// 작업자 호소 편집 트리거.
// 호소 내역 카드의 [편집] 버튼이 신규 입력 form 의 fields 를 prefill 하고 모드를 '수정' 으로 전환시킨다.
//
// 동작:
//   data-* 속성으로 호소 데이터를 받아 'worker-complaint:edit' CustomEvent 를 document 에 dispatch.
//   form 에 attach 된 worker-complaint-edit-mode 컨트롤러가 listen 해 form 활성화.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    const ds = event.currentTarget.dataset
    document.dispatchEvent(new CustomEvent("worker-complaint:edit", { detail: { ...ds } }))
  }
}
